module.exports = __webpack_public_path__ + "img/imprint-material.a0d0dd54.png";